var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2395",
    "data-name": "Rectangle 2395",
    width: 38,
    height: 38,
    rx: 9,
    fill: "#fff1d6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Facebook",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook-2",
    "data-name": "facebook",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5208",
    "data-name": "Path 5208",
    d: "M18.892,37.784H9.446A9.446,9.446,0,0,1,0,28.339V9.446A9.446,9.446,0,0,1,9.446,0H28.338a9.446,9.446,0,0,1,9.446,9.446V28.338a9.446,9.446,0,0,1-9.446,9.446H24.8a2.952,2.952,0,1,0-5.9,0Z",
    transform: "translate(0 0)",
    fill: "#3764b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5209",
    "data-name": "Path 5209",
    d: "M17.755,10.412H28.408a5.275,5.275,0,0,0,5.32-4.939A5.245,5.245,0,0,0,28.953.027C28.772.017,28.592,0,28.408,0H9.469A9.364,9.364,0,0,0,0,9.254v18.51A17.558,17.558,0,0,1,17.755,10.412",
    transform: "translate(0 0)",
    fill: "#507dd2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5210",
    "data-name": "Path 5210",
    d: "M39.755,24.5A9.255,9.255,0,1,0,49.01,33.76V15.25A9.255,9.255,0,0,1,39.755,24.5",
    transform: "translate(-11.226 -5.23)",
    fill: "#1e4ba0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5211",
    "data-name": "Path 5211",
    d: "M39.071,14.159a1.157,1.157,0,0,1-1.157,1.157H34.443a1.157,1.157,0,0,0-1.157,1.157V21.1H37.66a1.157,1.157,0,0,1,1.134,1.384L38.1,25.954a1.157,1.157,0,0,1-1.134.93H33.287V40.766H27.5V26.884H24.032a1.157,1.157,0,0,1-1.157-1.157V22.257A1.157,1.157,0,0,1,24.032,21.1H27.5V16.472a6.941,6.941,0,0,1,6.941-6.941h3.471a1.157,1.157,0,0,1,1.157,1.157Z",
    transform: "translate(-8.483 -2.982)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.785f5c71137d94976ef23c8105bc2ebc.svg";
export { ForwardRef as ReactComponent };